import { render } from "./DayHours.vue?vue&type=template&id=22237772&scoped=true"
import script from "./DayHours.vue?vue&type=script&lang=js"
export * from "./DayHours.vue?vue&type=script&lang=js"

import "./DayHours.vue?vue&type=style&index=0&id=22237772&scoped=true&lang=css"

import exportComponent from "/home/user/dev/teacher-soft/datepickerDev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22237772"]])

export default __exports__